import useAuthStore from "../store/authStore";
import DealEntryPage from "./DealEntryPage";
import "../styles/home.css";

function HomePage() {
  const { user } = useAuthStore();

  return (
    <div className="home-container">
      <div className="welcome-section">
        <h1 className="welcome-title">
          Welcome back, {user?.name?.split(' ')[0] || 'User'}!
        </h1>
        <p className="welcome-subtitle">
          Ready to analyze your next multifamily deal with AI-powered intelligence?
        </p>
        <div className="user-stats">
          <div className="stat-card">
            <span className="stat-label">Unlimited Deals</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">16</span>
            <span className="stat-label">Acquisition Pipeline Stages</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">AI</span>
            <span className="stat-label">Powered</span>
          </div>
        </div>
      </div>

      <DealEntryPage />
    </div>
  );
}

export default HomePage;
